import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import topTitle from '@/components/title';
import { validateIdCardNo } from '@/utils/validate';
import { ADD, MINPREMIUM } from './util';
import moment from 'moment';
import mixin from './mixin.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    policyInfo: {
      type: Object,
      default: () => ({})
    },
    professionInfo: {
      type: Array,
      default: () => []
    },
    yearDays: {
      type: Number,
      default: 365
    },
    effectiveDate: {
      type: String,
      default: ''
    },
    policyPurpose: {
      type: String,
      default: 'other'
    },
    insurancePlan: {
      type: Array,
      default: () => {}
    },
    occupationTypeOptions: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [mixin],
  components: {
    topTitle
  },
  data() {
    return {
      form: {},
      loading: false,
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      defaultValue: moment('00:00:00', 'HH:mm:ss')
    };
  },
  computed: {
    rules() {
      return {
        insurancePlanCode: [{
          required: true,
          message: this.$t('请选择') + this.$t('保险方案'),
          trigger: 'change'
        }],
        jobNumber: [{
          required: true,
          message: this.$t('请选择') + this.$t('工种'),
          trigger: 'change'
        }],
        occupationType: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('工种类别'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        dispatchCompany: [{
          required: true,
          trigger: 'blur',
          message: '劳动合同单位（共同被保险人）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        contractCompany: [{
          required: true,
          trigger: 'blur',
          message: '请输入劳动合同单位（合同主体）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        identificationType: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('名称'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        startAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('责任起期')
        }],
        idNumber: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }],
        remark: [{
          max: 200,
          message: this.$t('请输入长度200以内的内容'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }]
      };
    }
  },
  watch: {
    dialogVisible: {
      handler(newVal) {
        var _this$$refs;
        if (!newVal) return;
        this.form = {};
        (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.dataFrom) === null || _this$$refs === void 0 || _this$$refs.resetFields();
        const {
          policyNo,
          insuranceName,
          startAt,
          endAt,
          planId,
          insurancePlanName
        } = this.policyInfo;
        this.form = {
          policyNo,
          insuranceName,
          beginTime: startAt,
          endTime: endAt,
          planId,
          insurancePlanName,
          startAt: '',
          occupationType: '',
          identificationType: undefined,
          jobNumber: undefined
        };
        if (this.policyPurpose === 'groupInsurance') {
          this.$set(this.form, 'insurancePlanCode', undefined);
          this.$set(this.form, 'insurancePlanName', '');
          this.$set(this.form, 'contractCompany', '');
          this.$set(this.form, 'dispatchCompany', '');
          // this.form.insurancePlanCode = '';
          // this.form.insurancePlanName = '';
        }
        this.$set(this.form, 'startAt', moment(this.effectiveDate).format('YYYY-MM-DD') + ' 00:00:00');
        let endTime = this.policyInfo.endAt;
        let premium = this.calcPrice(this.form.startAt, endTime, this.policyInfo.premium);
        this.form.premium = premium;
        if (this.identificationTypeData.length === 1) {
          this.form.identificationType = this.identificationTypeData[0].value;
        }
        if (this.professionInfo.length === 1) {
          this.$set(this.form, 'jobNumber', this.professionInfo[0].jobNumber);
        }
      },
      immediate: true
    }
  },
  methods: {
    changeInsurancePlan(value) {
      this.form.occupationType = this.occupationTypeOptions[value] || '';
      this.$refs.dataFrom.validateField('occupationType');
    },
    validateCard(rule, idcard, callback) {
      let idCardTrim = (idcard === null || idcard === void 0 ? void 0 : idcard.trim()) || idcard;
      if (!validateIdCardNo(idCardTrim) || idCardTrim == '') {
        callback(new Error(this.$t('请输入正确的身份证号')));
      } else {
        callback();
      }
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          var _this$identificationT, _idNumber$trim;
          const {
            jobNumber,
            name,
            identificationType,
            occupationType,
            idNumber,
            startAt,
            premium,
            remark
          } = this.form;
          let price = this.calcRealyPrice(this.form.startAt, this.policyInfo.endAt, this.policyInfo.premium);
          if (price > 0 && price < MINPREMIUM) {
            this.$message.error(this.$t('保费金额过小无法计算，请联系平台管理员'));
            return;
          }
          if (!premium && premium !== 0) {
            this.$message.error(this.$t('保费为空'));
            return;
          }
          let selectOccupation = this.professionInfo.filter(item => item.jobNumber === jobNumber);
          let occupation = selectOccupation.length > 0 ? selectOccupation[0].occupation : '';
          let identificationText = ((_this$identificationT = this.identificationTypeData.filter(item => item.value === identificationType)[0]) === null || _this$identificationT === void 0 ? void 0 : _this$identificationT.label) || '';
          let obj = {
            policyId: this.policyInfo.id,
            jobNumber,
            occupation,
            occupationType,
            name: (name === null || name === void 0 ? void 0 : name.trim()) || '',
            identificationType: identificationText,
            idNumber: (idNumber === null || idNumber === void 0 || (_idNumber$trim = idNumber.trim()) === null || _idNumber$trim === void 0 ? void 0 : _idNumber$trim.toLocaleUpperCase()) || '',
            startAt,
            endAt: this.policyInfo.endAt,
            premium,
            type: ADD,
            remark: (remark === null || remark === void 0 ? void 0 : remark.trim()) || ''
          };
          if (this.policyPurpose === 'groupInsurance') {
            obj.insurancePlanCode = this.form.insurancePlanCode;
            let planObj = this.insurancePlan.filter(item => item.mark === this.form.insurancePlanCode);
            obj.insurancePlanName = (planObj === null || planObj === void 0 ? void 0 : planObj.length) > 0 ? planObj[0].name : '';
            obj.contractCompany = this.form.contractCompany;
            obj.dispatchCompany = this.form.dispatchCompany;
          }
          this.$emit('personnelEntrySave', obj);
        }
      });
    },
    cancel() {
      this.$emit('update:dialogVisible', false);
    }
  }
};